import { render } from "./ContattiPage.vue?vue&type=template&id=80c39448&scoped=true"
import script from "./ContattiPage.vue?vue&type=script&lang=js"
export * from "./ContattiPage.vue?vue&type=script&lang=js"

import "./ContattiPage.vue?vue&type=style&index=0&id=80c39448&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80c39448"]])

export default __exports__